import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService, Command, AttLogCommand } from '../shared/dataService';
import { Device } from '../shared/interfaces/deviceInfo'
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-device-info.component',
  templateUrl: './device-info.component.html',
  styleUrls: ['./device-info.component.css']
})
export class DeviceInfoComponent implements OnInit
{
   
    public dataSource: Device[] = [];
    public updateDevice: Device;
    public insertDevice: Device;
    public editorOptions: boolean ;
    checkBoxesMode: string;
    showFirstSubmenuModes: any;
    showSubmenuModes: any;
    public selectedRowsData: Array<number>  = [];
    public  commands: Command[];
    popupAttlogVisible = false;
    public popupTimeZone = false;
    private attlogCommand :AttLogCommand  = new AttLogCommand();
    private  devicesSN :string  = "";
    sendCommand:boolean =false;
    public timeZone:number = -6; 
    constructor(private router: Router, private data: DataService)
    {
        if (this.data.loginRequired)
        {
            console.log("redireccionar a el inicio de sesión")
            this.router.navigate(["/account"]);
        }
        console.log("Componet device-info");
        this.attlogCommand.startTime  = new Date(Date.now());
        this.attlogCommand.endTime    = new Date(Date.now());
        //this.attlogCommand.endTime.setDate( (this.attlogCommand.startTime.getDate()+ 30));
        this.commands                 = data.getCommands;

        this.showSubmenuModes = [{
            name: "onHover",
            delay: { show: 0, hide: 500 }
        }, 
        {
            name: "onClick",
            delay: { show: 0, hide: 300 }
        }];
        this.showFirstSubmenuModes = this.showSubmenuModes[1];
        this.checkBoxesMode = 'onClick';
        //this.initDataSource();
    }
    public  periodos = [
        {"ID": 30,"Name": "30"}, 
        {"ID": 60,"Name": "60"},
        {"ID": 90,"Name": "90"},
    ]; 
    public allMode = 'page';
    public popupTitle = '';
    public popupcmd = '';
    public fiDisabled = true;
    public ffDisabled = true;
    public periodo = 30;
    public rdAttLog = true;

    //public checkBoxesMode = 'always'; //"onClick" | "onLongTap" | "always"
    ngOnInit(): void
    { 
        this.allMode = 'allPages';
        this.editorOptions = true;  
        this.initDataSource();
    }
    onAttLogShowInfo(data)
    { 
        this.popupAttlogVisible = true;
    }
    onTimeZoneShowInfo()
    {
        this.popupTimeZone= true;

    }
    onTimeZoneCommand()
    {
        //antes de mandar el info actualziar los biometricos.
        if (this.selectedRowsData != undefined && this.selectedRowsData.length > 0) 
        {
            this.sendCommand = true;
            //validar que tz este en el rango valido
            
            console.log(this.selectedRowsData) 
            this.data.queryTimeZone(this.devicesSN,this.timeZone)
            .subscribe(sucess => 
                {
                    if (sucess)
                    { 
                      console.log(" device timezone result "+this.data.ressultCheck);
                      this.sendCommand = false;
                      this.initDataSource();
                    }
                }, error=>
                {  
                    console.log(error);
                    this.sendCommand = false;
                }  
                
            );
           
        } 
        this.popupTimeZone = false; 
    }
    itemClick(data)
    {
        //validar que tenga dispositvos selccionados 
        //console.log(this.selectedRowsData);

        //if(data.itemData.command != undefined)
        if(this.selectedRowsData != undefined &&
            this.selectedRowsData.length > 0)
        {
            this.popupcmd = data.itemData.command;
            switch (data.itemData.command) 
            {
                case 'timeZone':
                    console.log("comando de timeZone");
                    this.onTimeZoneShowInfo()
                    break;
                case'attlog':
                    this.rdAttLog=true;
                    this.popupTitle = 'Traer registros';
                    //this.fiDisabled = false;
                    //this.ffDisabled = true;
                    this.onAttLogShowInfo('attlog')
                    break;
                case'delLog':
                    this.rdAttLog=false;
                    this.popupTitle = 'Borrar registros';
                    //this.fiDisabled = true;
                    //this.ffDisabled = false;
                    //var date = new Date(); // Now
                    //date.setDate(date.getDate() - 30);
                    //this.attlogCommand.endTime = date;
                    //alert(this.attlogCommand.endTime);
                    
                    //this.popupAttlogVisible = true;
                    this.onAttLogShowInfo('attlog');
                    break;
                case'check':
                    this.onCheckCommand();
                    break;
                case'checkUsers':
                    this.onCheckUsers();
                    break;                    
                case'devInfo':
                    this.onDevInfo();
                    break;
                default:
                console.log("comando no registrado");
                    break; 
            }
            //console.log(data.itemData.command);
        }
        else{
            notify("Favor de seleccionar un dispositivo");
        }
    }
    onDevInfo() : any 
    {
        console.log("Commando onDevInfo");
       
        if (this.selectedRowsData != undefined && this.selectedRowsData.length > 0) 
        {
            this.sendCommand = true;
            console.log(this.selectedRowsData) 
            this.data.queryDevInfo(this.devicesSN)
            .subscribe(sucess => 
                {
                    if (sucess)
                    { 
                      console.log(" device info result "+this.data.ressultCheck);
                      this.sendCommand = false;
                      this.initDataSource();
                    }
                }, error=>
                {  
                    console.log(error);
                    this.sendCommand = false;
                }  
                
            );
           
        } 
    };

    onCheckCommand(): any 
    {
        console.log("Comando onCheckCommand ");
        
        if (this.selectedRowsData != undefined && this.selectedRowsData.length > 0)
        {
            this.sendCommand = true;
            console.log(this.selectedRowsData)
            this.data.queryCheck(this.devicesSN)
            .subscribe(sucess => 
                {
                    if (sucess)
                    { 
                      console.log(" check result "+this.data.ressultCheck);
                      this.sendCommand = false;
                      this.initDataSource();
                    }
                }, error=>
                {
                      console.log(error);this.sendCommand = false;
                }  
            ); 
        }   
    }

    onCheckUsers(): any 
    {
        console.log("Comando onCheckUsers");
        if (this.selectedRowsData != undefined && this.selectedRowsData.length > 0){
        this.sendCommand = true;
        //console.log(this.selectedRowsData)
        this.data.queryCheckUsers(this.devicesSN)
        .subscribe(sucess => 
            {
                if (sucess)
                { 
                    console.log(" check result "+this.data.ressultCheck);
                    this.sendCommand = false;
                    this.initDataSource();
                }
            }, error=>
            {
                    console.log(error);this.sendCommand = false;
            }  
        ); 
        }   
    }

    onSelectedRowsData(e: any): any 
    {
        this.selectedRowsData =[]
        this.devicesSN = "";
        e.selectedRowsData.forEach(element => 
            {
                console.log(element);
                this.selectedRowsData.push(element.id);
                this.devicesSN+= element.deviceSN+",";
                
                /*
                if(element.state == 'OffLine' || element.state == 'SL'){
                    alert("El dispositivo" + element.deviceSN + "No puede ser seleccionado debido a su estado " + element.state);
                }
                else{
                    this.selectedRowsData.push(element.id);
                    this.devicesSN+= element.deviceSN+",";
                }
                */
                //eliminar el ultimo ","   
            });   
        //console.log(this.selectedRowsData);//Es todo el log seleccionado
        
    } 
    private initDataSource()
    {
        this.data.loadDevices()
            .subscribe(sucess => {
                if (sucess) {
                    
                    this.dataSource = this.data.devices; 
                }
            });
    }

    public onCellClick(e)
    { 
        console.log('Cell ' + e.columnIndex + ' clicked');
        if (e.columnIndex == 2 || e.columnIndex == 3)
        {
          //  e.event.stopImmediatePropagation();
            // Other code omitted
        }
    }
    onSelectRow()
    {
        console.log(this.dataSource);
    }
    logEvent(eventName,event)
    {
        
        switch(eventName)
        {
            case 'InitNewRow':
                this.editorOptions = false;
            break;
            case'RowInserted': 
                this.onRowInserted(event);
            break;
            case 'EditingStart':
                this.editorOptions = true;
            break;
            case 'RowUpdated':
                this.OnRowUpdated(event);
            break;
            case 'eventSelect':
                this.onSelectedRowsData(event);
            break;
            default:
                console.log("evento no programado");
        }
        
    }
    onRowInserted(e: any) 
    {
         
        console.log(e);
        //this.data.updateDeviceBySN("BOCB182460271");
        this.data.addDevice(e.key)
        .subscribe(sucess => 
            {
                if (sucess)
                { 
                    this.insertDevice = this.data.insertDevice;
                    console.log(this.insertDevice);
                    this.initDataSource();
                }
            }  
        );
        console.log("terminar de insertar");
    }
    
    OnRowUpdated(e)
    {
        
        console.log(e);
        //this.data.updateDeviceBySN("BOCB182460271");
        this.data.updateDeviceBySN(e.key)
        .subscribe(sucess => 
            {
                if (sucess)
                { 
                    this.updateDevice = this.data.updateDevice;
                    console.log(this.updateDevice);
                    this.initDataSource();
                }
            }  
        );
        console.log("terminar de editar");
    }
    onValueChangedDateStart(e:any)
    {
        //alert("aqui");
        /*
        this.attlogCommand.endTime = new Date(); 
        this.attlogCommand.endTime.setDate( (this.attlogCommand.startTime.getDate()+ 30));
        */
    } 
    onValueChangedDateEnd(e:any)
    {
        //this.attlogCommand.startTime = new Date(); 
        //this.attlogCommand.startTime.setDate( (this.attlogCommand.endTime.getDate()+ 30));
    } 
    /**Comandos */
    onAttLogCommand()
    {
        console.log("Comando OnAttlog "); 
        if (this.selectedRowsData != undefined && this.selectedRowsData.length > 0) {
            console.log(this.selectedRowsData);
            this.sendCommand = true;
            //obtener la lista de los numeros de serie    
            this.attlogCommand.deviceSN= this.devicesSN;
            //console.log(this.attlogCommand.startTime.getDate());
            //console.log(this.attlogCommand.endTime.getDate());
            if(this.popupcmd=='attlog'){
                this.attlogCommand.endTime = new Date();
                this.attlogCommand.endTime.setHours(24,0,0,0);
                var date = new Date(); // Now
                date.setDate(date.getDate() - this.periodo);
                this.attlogCommand.startTime = date;
                this.attlogCommand.startTime.setHours(0,0,0,0);
                console.log(this.attlogCommand);

                this.data.queryAttLog(this.attlogCommand)
                .subscribe(sucess => 
                    {
                        if (sucess)
                        { 
                          //console.log(this.data);//el resultado tiene que ser un 0
                          //console.log("success " + sucess);//el resultado tiene que ser un 0
                          //console.log("Attlog command " + this.data.resultAttLog);//el resultado tiene que ser un 0
                          if(this.data.resultAttLog=='Ok'){
                            notify("La solicitud ha sido enviada.");
                            this.sendCommand = false;
                          }
                          else{
                            notify("Ocurrió un error al enviar la solicitud.");
                          }
                          
                        }
                    }, error=>{  console.log(error);this.sendCommand = false;}  
                );                
            } 
            if(this.popupcmd=='delLog'){
                //Para esta opción, la fecha de inicio es irrelevante
                var date = new Date(); // Now
                date.setDate(date.getDate() - 90);
                this.attlogCommand.startTime = date;
                this.attlogCommand.endTime = date;
                this.data.delAttLog(this.attlogCommand)
                .subscribe(sucess => 
                    {
                        if (sucess)
                        { 
                            if(this.data.resultAttLog=='0'){
                                notify("La solicitud ha sido enviada.");
                                this.sendCommand = false;
                              }
                              else{
                                notify("Ocurrió un error al enviar la solicitud.");
                              }
                          //console.log("Del command " + this.data.resultAttLog);//el resultado tiene que ser un 0
                          //this.sendCommand = false;
                        }
                    }, error=>{  console.log(error);this.sendCommand = false;}  
                );                
            } 
            this.initDataSource();
        }
        this.popupAttlogVisible = false; 
        
    }
}
